// ScrollHint — flecha bouncing abajo a la derecha que indica al cliente
// "hay más contenido si scrolleás". Se oculta cuando:
//   - el usuario scrolleó más de 80px desde arriba
//   - la página NO tiene scroll (todo entra en el viewport)
//   - el usuario llegó al fondo
// Reactiva al cambiar de ruta o si crece el contenido.

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollHint() {
  const location = useLocation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let raf = null

    function chequear() {
      const docHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight || 0
      )
      const viewport = window.innerHeight
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0

      const tieneScroll = docHeight - viewport > 40
      const estaArriba = scrollY < 80
      const llegoAlFondo = scrollY + viewport >= docHeight - 20

      setVisible(tieneScroll && estaArriba && !llegoAlFondo)
    }

    function onScrollOrResize() {
      if (raf) cancelAnimationFrame(raf)
      raf = requestAnimationFrame(chequear)
    }

    // Esperar a que se rendericen las imágenes/contenido async antes de medir
    const t1 = setTimeout(chequear, 100)
    const t2 = setTimeout(chequear, 600)
    const t3 = setTimeout(chequear, 1500)

    window.addEventListener('scroll', onScrollOrResize, { passive: true })
    window.addEventListener('resize', onScrollOrResize)

    return () => {
      window.removeEventListener('scroll', onScrollOrResize)
      window.removeEventListener('resize', onScrollOrResize)
      if (raf) cancelAnimationFrame(raf)
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3)
    }
  }, [location.pathname])

  if (!visible) return null

  return (
    <button
      type="button"
      className="scroll-hint"
      aria-label="Scroll hacia abajo para ver más"
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.7, behavior: 'smooth' })}
    >
      <span className="scroll-hint-label">Hay más abajo</span>
      <span className="scroll-hint-arrow" aria-hidden="true">↓</span>
      <style>{`
        .scroll-hint {
          position: fixed; right: 16px; bottom: 88px;
          background: #1A3461; color: #fff;
          border: none; border-radius: 999px;
          padding: 9px 14px; font-family: inherit;
          font-size: 12.5px; font-weight: 700;
          display: inline-flex; align-items: center; gap: 6px;
          cursor: pointer; box-shadow: 0 6px 20px rgba(15,23,42,0.25);
          z-index: 90;
          animation: scroll-hint-in 0.3s ease-out, scroll-hint-bounce 1.8s ease-in-out 0.4s infinite;
        }
        .scroll-hint:hover { background: #1A3461; }
        .scroll-hint-arrow { font-size: 14px; line-height: 1; }
        @keyframes scroll-hint-in {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes scroll-hint-bounce {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-6px); }
        }
        @media (max-width: 640px) {
          .scroll-hint { bottom: 76px; padding: 8px 12px; font-size: 12px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .scroll-hint { animation: scroll-hint-in 0.3s ease-out; }
        }
      `}</style>
    </button>
  )
}
